/* eslint react/no-danger: 0, react/no-array-index-key: 0 */
import React, { useEffect, useRef, useState } from 'react';
import Observer from 'react-intersection-observer';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Accordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AddIcon from "@material-ui/icons/Add";
import TabScrollButton from '@material-ui/core/TabScrollButton';
import RemoveIcon from "@material-ui/icons/Remove";
import content from "../../content";
import { GAfireEvent } from "../Tracking";
import { COMMUNITIES_TO_NAMES, EXIT_OVERLAY_EXCEPTIONS, WF_OWNED_SITES } from "../../constants";

import { fireTag } from '../../libs/analytics';


const AccordionSummary = withStyles({
	root: {
		disableRipple: true,
	},
	expandIcon: {
		order: 0,
		disableRipple: true,
	},
	expanded: {},
})(MuiAccordionSummary);


const Highlights = props => {
	const [value, setValue] = useState(0);
	const copy = content.sustainability.highlights;
	const containerRef = useRef(null);
	const tabPanelRef = useRef(null);
	const {addExitClickListeners} = props;

	const resizeTabPanel = () => {

		window.setTimeout(() => {
			if (window.innerWidth >= 1080) {
				const tabPanel = document.querySelector('.tabpanel:not([hidden])');
				const image = document.querySelector('.tabpanel:not([hidden]) .accordion-img');
				if (tabPanel && image) {
					tabPanel.style.height = parseInt(getComputedStyle(image).height.replaceAll('px', ''), 10) + 100 + 'px'
				}
			}
			else if (window.innerWidth >= 768) {
				const tabPanel = document.querySelector('.tabpanel:not([hidden])');
				if (tabPanel) {
					tabPanel.style.height = ''
				}
			}
		}, 1)
	}

	const handleTabChange = (event, newValue) => {
		setValue(newValue);
		resizeTabPanel();
		addExitClickListeners();
	};

	const [expanded, setExpanded] = React.useState(['panel0']);

	const handleAccordionChange = (panel) => (event, newExpanded) => {
		const isNewItem = expanded.includes(panel) !== true;
		const expandedUpdate = (isNewItem) ? [...expanded, panel] : [...expanded].filter(item => item !== panel);
		setExpanded(expandedUpdate);
	};

	const renderAccordion = (facet, i) =>

		<Accordion
			key={i}
			className="facet"
			square
			elevation={0}
			onChange={handleAccordionChange(`panel${i}`)}
			expanded={expanded.includes(`panel${i}`)}
		>
			<AccordionSummary
				aria-controls={`panel${i}a-content`}
				id={`panel${i}a-highlights-header`}
				className="tab"
				disableRipple
				expandIcon={expanded.includes(`panel${i}`) ? <RemoveIcon/> : <AddIcon/>}
			>

				<p className="heading" dangerouslySetInnerHTML={{__html: facet.tab.header}}/>

			</AccordionSummary>
			<AccordionDetails className="drawer">
				<p className="heading" dangerouslySetInnerHTML={{__html: facet.tab.subheader}}/>
				{facet.panel.cta && 
				<a className="read-watch"
					href={facet.panel.cta.href}
					// target="_blank"
					target={`${facet.panel.cta.noBlank ? '' : '_blank'}`}
					rel="noreferrer"
					onClick={() => {
						// alert('click')
						/*
						GAfireEvent(
							`${facet.panel.cta.gaTag}`,
							{action: copy.headline.toLowerCase(), label: `${facet.tab.cta.copy.toLowerCase()}: ${facet.tab.header.toLowerCase().split(' ').slice(0, 3).join(' ')}`}
						)
						*/
					}}
				>
					{facet.panel.cta.copy}

				</a>}
				<div className={`accordion-img ${facet.panel.imageClass}`} role="img" alt={`${facet.panel.altText}`} aria-label={`${facet.panel.altText}`}><span/></div>
			</AccordionDetails>
		</Accordion>


	useEffect(() => {

		resizeTabPanel();
		window.addEventListener('resize', () => resizeTabPanel());
		addExitClickListeners();

	}, [addExitClickListeners])

	let scrollHighlights = false;

	useEffect(() => {
		window.addEventListener('scroll',()=>{
			if(window.location.href.includes('/sustainability/') && !scrollHighlights && document.querySelector('#sustainability__highlights').getBoundingClientRect().top <= document.querySelector('nav').getBoundingClientRect().height){
				scrollHighlights = true;
				fireTag('S3');
			}
		});
	},[])

	return (
		<Observer
			tag="section"
			id="sustainability__highlights"
			className="sustainability__highlights"
			ref={containerRef}
			threshold={0.5}
			triggerOnce
			onChange={inView => {
				if (inView) {
					//GAfireEvent('isf_S1');
					//fireTag('S3');
				}
			}}
		>
			<h2 id="highlights-heading" dangerouslySetInnerHTML={{__html: copy.headline}}/>

			<div className="tab-accordion-container">

				{
					(window.innerWidth >= 768 && (
						<div className="tab-interface">
							<Tabs
								TabIndicatorProps={{style: {display: "none"}}}
								orientation="vertical"
								variant="scrollable"
								scrollButtons="auto"
								value={value}
								onChange={handleTabChange}
								className="tab-list"
								aria-labelledby="highlights-heading"
								selectionFollowsFocus
							>
								{copy.tiles.map((tile, i) => (
									<Tab
										className="tab"
										tabIndex={value === i ? 0 : -1}
										id={`highlight-tab-${i}`}
										aria-controls={`scrollable-auto-tabpanel-${i}`}
										key={i}
										onClick={() => {
											/*
											GAfireEvent(
												`${tile.tab.gaTag}`,
												{action: copy.headline.toLowerCase(), label: tile.tab.header.toLowerCase().split(' ').slice(0, 3).join(' ')}
											);
											*/
										}}
										label={
											<>
												<div className="heading-container">
													<p className="heading" dangerouslySetInnerHTML={{__html: tile.tab.header}}/>
												</div>
											</>
										}/>

								))}

							</Tabs>

							{copy.tiles.map((tile, i) => (
								<div
									className="tabpanel"
									role="tabpanel"
									key={i}
									hidden={value !== i}
									id={`scrollable-auto-tabpanel-${i}`}
									ref={tabPanelRef}
									aria-labelledby={`highlight-tab-${i}`}
									tabIndex={value === i ? 0 : -1}
								>
									<p
										className="subheading"
										dangerouslySetInnerHTML={{__html: tile.tab.subheader}}
									/>
									{
										tile.tab.cta && 

										<a className="read-watch"
										tabIndex={value === i ? 0 : -1}
										href={tile.tab.cta.href}
										target={`${tile.tab.cta.noBlank ? '' : '_blank'}`}
										rel="noreferrer"
										onClick={() => {
											fireTag('C4', `view report: ${tile.tab.header.toLowerCase()}`);
											/*
											GAfireEvent(
												`${tile.tab.cta.gaTag}`,
												{action: copy.headline.toLowerCase(), label: `${tile.tab.cta.copy.toLowerCase()}: ${tile.tab.header.toLowerCase().split(' ').slice(0, 3).join(' ')}`}
											)
											*/
										}}
									>
										{tile.tab.cta.copy}
									</a>
									}
									<div className={`accordion-img ${tile.panel.imageClass}`} role="img" alt={`${tile.panel.altText}`} aria-label={`${tile.panel.altText}`}><span/></div>
								</div>
							))}

						</div>
					))
				}

				{
					(window.innerWidth < 768 && (
						<div className="accordion-interface">
							{copy.tiles.map((x, i) => renderAccordion(x, i))}
						</div>
					))
				}

			</div>
		</Observer>
	);
}

export default Highlights;



